import { Box } from '@mui/material';
import './index.css';
import ZendeskLink from 'components/Common/ZendeskLink';
import CheckIcon from 'assets/fi_check-circle.svg';
import CloseIcon from 'assets/closed-circle.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { resendEmail } from 'store/actions/authActions';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Button from 'components/Common/Button';
import { PRIMARY_BUTTON } from 'themes/theme';

const ResendEmail = () => {
    const [showSpinner, setSpinner] = useState();
    const [hasError, setError] = useState(false);
    const [mailSent, setMailSent] = useState(false);
    const emailInfo = useSelector(state => state.authReducer);

    useEffect(() => {
        resendEmail(emailInfo.email.toLowerCase(), (val, sent, isFail) => callBackMethod(val, false, isFail))
    }, [emailInfo.email])

    const callBackMethod = (val, sent, isFail) => {
        setSpinner(val);
        setError(isFail);
        if (sent) {
            setMailSent(true);
        }
    }
    const handleResend = () => {
        resendEmail(emailInfo.email.toLowerCase(), (val, sent,isFail) => callBackMethod(val, sent, isFail))
    }
    return (
      <Box
        padding="30px"
        height="100%"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        display="flex"
        color="#25245f"
      >
        {!hasError ? (
          <>
            <Box marginTop="20%" className="mb-5">
              <img src={CheckIcon} alt="checked" />
            </Box>
            <h4 className="authTitle text-center">
              Check your email and
              <br /> let's get started
            </h4>
          </>
        ) : (
          <Box marginTop="20%" textAlign="center">
            <img src={CloseIcon} alt="checked" />
            <Box fontSize="22px" fontWeight={600} className="mt-5">
              Exceeded maximum reset limit!
              <br />
              Please contact your administrator.
            </Box>
          </Box>
        )}
        <Box className="my-5" width="330px" textAlign="center">
          <Button type={PRIMARY_BUTTON} loading={showSpinner} onClick={handleResend} submit>
            Resend email
          </Button>
        </Box>
        {mailSent && (
          <Box
            color="#398468"
            alignItems="center"
            border="solid 1px #398468"
            borderRadius="8px"
            padding="10px"
            display="flex"
            gap="10px"
          >
            <Box>
              <FontAwesomeIcon fontSize="18px" className="font-weight-bold" icon={faCheckCircle} />
            </Box>
            <Box fontSize="14px" fontWeight={400}>
              Verification email has been resent to {emailInfo.email}
            </Box>
            <Box sx={{ cursor: 'pointer' }} onClick={() => setMailSent(false)}>
              <FontAwesomeIcon fontSize="18px" icon={faClose} />
            </Box>
          </Box>
        )}
        <Box marginTop="auto">
          <ZendeskLink />
        </Box>
      </Box>
    )
};

export default ResendEmail;